import { render } from "./EditApprovisionnement.vue?vue&type=template&id=5e2e7606&scoped=true"
import script from "./EditApprovisionnement.vue?vue&type=script&lang=js"
export * from "./EditApprovisionnement.vue?vue&type=script&lang=js"

import "./EditApprovisionnement.vue?vue&type=style&index=0&id=5e2e7606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2e7606"]])

export default __exports__